import { graphql } from 'react-relay';
import type { HubPages_Pagination_Query$variables } from './__generated__/HubPages_Pagination_Query.graphql';

export * from './__generated__/HubPage_Fragment.graphql';
const HubPageFragment = graphql`
  fragment HubPage_Fragment on HubPage {
    id
    __typename
    title
    description
    status
    statusSettings {
      ...Frags_Status_Settings_Fragment @relay(mask: false)
    }
    content
    author {
      ...Frags_Wiz_Author_Fragment @relay(mask: false)
    }
    created
    modified
    formId
    form {
      node {
        ...Frags_Frontend_Form_Fragment @relay(mask: false)
      }
    }
    connectionHpToCs(first: 100, where: { order: ASC, orderBy: CatalogOrder }) {
      edges {
        node {
          catalogId
          catalogOrder
          catalog {
            node {
              ...ZnglyVideo_Pagination_Node_Fragment @relay(mask: false)
            }
          }
        }
      }
    }
  }
`;

export type HubPages_Pagination_Fragment$args = HubPages_Pagination_Query$variables;

export type {
  HubPages_Pagination_Fragment$data,
  HubPages_Pagination_Fragment$key,
} from './__generated__/HubPages_Pagination_Fragment.graphql';
export const HubPagePaginationFragment = graphql`
  fragment HubPages_Pagination_Fragment on RootQuery 
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "RootQueryToHubPageConnectionWhereArgs" }
  )
  @refetchable(queryName: "HubPages_Pagination_Query") {
    hubPages(first: $first, after: $after, where: $where) @connection(key: "HubPages_Pagination_Fragment_Connection_hubPages") {
      __id
      edges {
        node {
          ...HubPage_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export type { HubPage_Query, HubPage_Query$data, HubPage_Query$variables } from './__generated__/HubPage_Query.graphql';
export const HubPagesQuery = graphql`
  query HubPage_Query($first: Int = 24, $after: String = null, $where: RootQueryToHubPageConnectionWhereArgs = { statusIn: [PUBLISH, HIDDEN, DRAFT, PENDING]}) {
    ...HubPages_Pagination_Fragment
    @arguments(
        first: $first
        after: $after
        where: $where
      )
  }
`;

export type {
  HubPage_Single_Query,
  HubPage_Single_Query$data,
  HubPage_Single_Query$variables,
} from './__generated__/HubPage_Single_Query.graphql';
export const HubPageSingleQuery = graphql`
  query HubPage_Single_Query($id: ID!) {
    hubPage(id: $id) {
      ...HubPage_Fragment @relay(mask: false)
    }
  }
`;
